import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductCardMarketplaceStateService {
  private _productCardMarketplaceState = signal<string>('');
  public productCardMarketplaceState = this._productCardMarketplaceState.asReadonly();

  public setProductCardMarketplaceState(path: string): void {
    const marketplace = path.split('-').at(0) || '';
    this._productCardMarketplaceState.set(marketplace);
  }

  public resetProductCardMarketplaceState(): void {
    this._productCardMarketplaceState.set('');
  }
}
